<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M1.14258 6.28564V9.71422"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.57031 3.42822V12.5711"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 0.571289V15.4284"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.4277 3.42822V12.5711"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.8574 6.28564V9.71422"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
